export default "__VITE_ASSET__DW6tojug__"